import React from "react";
import { isMobile } from "../../helperFunc";
import style from "./style.module.css";
import Button from "../Button";
import MultiLanguageTranslation from "../../../../../_components/Translate/MultiLangTranslate";
import HeadLines from "../HeadLines";
import useIsUserLoggedIn from "../../CustomHooks/useIsUserLoggedIn";

const LanguagePreferenceNotification = ({
  setShow = () => {},
  handleClick = () => {},
  setIsLanguagePreferenceClick = () => {},
}) => {
  const [userLoggedIn] = useIsUserLoggedIn();

  return (
    <div
      className={`${
        isMobile
          ? "backgroundLightBrown padding-top20 padding-bottom20 padding-left16 padding-right16"
          : "padding-top24"
      } 
    ${!isMobile && !userLoggedIn && "padding-left-right100"}`}
    >
      <div
        className={
          isMobile ? `${style.mobParentDiv}` : `${style.deskparentDiv}`
        }
      >
        <div
          className={
            isMobile
              ? `d-flex align-items-center flex-column gap16`
              : `d-flex align-items-center justify-content-space-between`
          }
        >
          <div
            className={`d-flex flex-column gap8 ${
              !isMobile && `align-items-center`
            }`}
          >
            <HeadLines
              className={`font-weight500 letterSpacing015 textColorWhite
            ${
              isMobile
                ? "line-height16 font-size14"
                : "line-height28 font-size24"
            }
         `}
              text="Receive notifications in preferred language"
            />
            <HeadLines
              className={`font-weight400 letterSpacing015 ${
                style.headingText
              } ${
                isMobile
                  ? `line-height16 font-size14`
                  : `line-height19 font-size16`
              }
          `}
              text="Get notifications in English, Hindi, Marathi, Gujarati or Telugu"
            />
          </div>
          <Button
            className={`${
              isMobile
                ? `padding-top12 padding-bottom12 font-size14 line-height16 w-100`
                : `${style.deskButtonPadding} font-size16 line-height19`
            } ${style.setPreference} font-weight500 letterSpacing015`}
            onClick={
              userLoggedIn
                ? handleClick
                : () => {
                    setShow(true);
                    setIsLanguagePreferenceClick(true);
                  }
            }
          >
            <MultiLanguageTranslation title="Set Preference" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LanguagePreferenceNotification;
